import { wsCall, requestHelper, setSuccess } from "../../../app/coreSlice";

const carclubCreateMessageCarclubCall = async (
  { setMessageSaveSuccess },
  dispatch,
  state,
  { bcc, body, subject, type, subType, toSpecificMail, specificMailList }
) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  let rh = requestHelper(dispatch, "CARCLUB/CREATE_MESSAGE_CARCLUB");
  try {
    const result = await wsCall({
      type: "CARCLUB",
      subType: "CREATE_MESSAGE_CARCLUB",
      locationId: selectedLocation?.id,
      message: {
        body,
        subject,
        bcc,
        type,
        subType,
        toSpecificMail,
        specificMailList,
      },
    });
    console.log("result: %o", result);
    if (result && !result.error) {
      dispatch(setSuccess("Notification created successfully"));
      dispatch(setMessageSaveSuccess(true));
      setTimeout(() => {
        dispatch(setMessageSaveSuccess(false));
      }, 200);
    } else {
      rh.error(result?.description || "Error creating notification!");
    }
  } catch (_ex) {
    rh.error("Error creating notification!");
  }
  rh.close();
};

export default carclubCreateMessageCarclubCall;
